import React from "react";

function Logo2() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="82mm"
      height="10mm"
      version="1.1"
      viewBox="0 0 82 10"
    >
      <g stroke="none">
        <text
          xmlSpace="preserve"
          style={{ lineHeight: "1.25" }}
          x="22.725"
          y="8.933"
          fill="#000"
          fillOpacity="1"
          strokeWidth="0.265"
          fontFamily="sans-serif"
          fontSize="10.583"
          fontStyle="normal"
          fontWeight="normal"
        >
          <tspan
            style={{}}
            x="22.725"
            y="8.933"
            strokeWidth="0.265"
            fontFamily="Tahoma"
            fontStretch="normal"
            fontStyle="normal"
            fontVariant="normal"
            fontWeight="bold"
          >
            <tspan fill="#fff">Better</tspan>
            <tspan fill="red">Tube</tspan>
          </tspan>
        </text>
        <rect
          width="19.945"
          height="9.766"
          x="0.186"
          y="0.109"
          fill="#fff"
          fillRule="evenodd"
          strokeDasharray="none"
          strokeMiterlimit="4"
          strokeOpacity="1"
          strokeWidth="0.2"
          paintOrder="normal"
          rx="3.044"
          ry="3.372"
        ></rect>
        <path
          fill="#000"
          fillOpacity="1"
          fillRule="evenodd"
          strokeDasharray="none"
          strokeMiterlimit="4"
          strokeOpacity="1"
          strokeWidth="1.002"
          d="M291.02 304.286l-10.675 6.163-10.675 6.163V291.96l10.675 6.163z"
          paintOrder="normal"
          transform="matrix(.18313 0 0 .18313 -41.227 -50.731)"
        ></path>
      </g>
    </svg>
  );
}

export default Logo2;
